(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-sticky-atc"]) return;
  try {
    
  (function () {
    const bar = document.getElementById('dc-sticky-atc');
    if (!bar) return;

    const stickyBtn = document.getElementById('dc-sticky-btn');
    const priceEl = document.getElementById('dc-sticky-price');

    function getMainAtcBtn() {
      return document.querySelector('.add-to-cart-button:not(#dc-sticky-btn)');
    }

    const mainBtn = getMainAtcBtn();
    if (!mainBtn) return;

    const footerEl =
      document.querySelector('.footer-content') ||
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer');

    let mainBtnVisible = true;
    let footerVisible = false;

    function updateStickyVisibility() {
      // La barra aparece solo si el botón principal NO está a la vista
      // y el footer tampoco, para que nunca lo tape.
      if (!mainBtnVisible && !footerVisible) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    const btnObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          mainBtnVisible = entry.isIntersecting;
        });
        updateStickyVisibility();
      },
      { threshold: 0.5 }
    );
    btnObserver.observe(mainBtn);

    if (footerEl) {
      const footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerVisible = entry.isIntersecting;
          });
          updateStickyVisibility();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footerEl);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        const realBtn = getMainAtcBtn();
        if (realBtn && !realBtn.disabled) {
          stickyBtn.classList.add('adding');
          realBtn.click();
          setTimeout(function () {
            stickyBtn.classList.remove('adding');
          }, 1200);
        }
      });
    }

    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && e.detail.variant;
      if (!variant || !priceEl) return;
      const cents = variant.price;
      const formatted = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
      }).format(cents / 100);
      priceEl.textContent = formatted;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
